<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Buitenlands loon
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Kies 'Buitenlands loon' als de werknemer buiten Nederland werkte, ook al was dit voor een
                Nederlandse werkgever.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingWerkenBelgie">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseWerkenBelgie" aria-expanded="false" aria-controls="collapseWerkenBelgie">
                Werken in België – waar betaal je belasting?
            </button>
        </h2>
        <div id="collapseWerkenBelgie" class="accordion-collapse collapse" aria-labelledby="headingWerkenBelgie"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                Het verdrag voorkomt dat je dubbel belasting betaalt, maar ook dat je in beide landen geen belasting betaalt. Je betaalt dus of in België, of in Nederland belasting over je inkomen. De hoofdregel is dat je belasting betaalt in het land waar je werkt (je werkland).

                <div class="space20"></div>

                <strong>Je werkt tijdelijk in loondienst in Nederland of België</strong><br>
                Woon je in Nederland en betaal je in Nederland belasting over je loon? En ga je voor je Nederlandse werkgever tijdelijk in België werken? Dan blijf je in Nederland belasting betalen. Deze regeling geldt andersom ook: als je in België woont, in België belasting betaalt over je loon en tijdelijk voor je Belgische werkgever in Nederland gaat werken, blijf je in België belasting betalen.<br><br>
                Je moet wel voldoen aan de volgende voorwaarden:
                <ul>
                    <li>Je verblijft in 12 maanden in totaal niet langer dan 183 dagen voor je werk in het werkland. De periode van 12 maanden hoeft niet in 1 kalenderjaar te zijn. Het maximale aantal dagen hoeft ook niet aaneengesloten te zijn. Gewone arbeidsonderbrekingen met verblijf in het werkland, zoals ziektedagen, weekenden en nationale feestdagen, tellen ook mee in het totaal van 183.</li>
                    <li>Je werkt in het werkland níet voor rekening van een vaste inrichting van je werkgever. Er is sprake van een vaste inrichting als je werkgever in je tijdelijke werkland een bedrijfsruimte duurzaam ter beschikking heeft, zoals een fabriek, werkplaats, magazijn of verkoopruimte.</li>
                </ul>
                Ben je langer dan 183 dagen in België, of betaalt de Belgische vaste inrichting jouw loonkosten, dan betaal je in België belasting over je loon.

                <div class="space20"></div>

                <strong>Je werkt voor een onderneming van je werkgever</strong><br>
                Moet je van je werkgever naar Nederland of België om daar tijdelijk te werken voor een onderneming van je werkgever, bijvoorbeeld een dochteronderneming? Dan betaal je over het loon dat je met dat werk verdient belasting in het land waar de (dochter)onderneming gevestigd is.<br><br>
                Met 'werken voor de onderneming van je werkgever' bedoelen we dat die (dochter)onderneming zelf het loon aan je uitbetaalt, of dat je werkgever de loonkosten doorberekent aan die (dochter)onderneming.

                <div class="space20"></div>

                <strong>Je werkt voor de overheid</strong><br>
                Werk je voor de overheid, dan betaal je over het inkomen dat je met dat werk verdient belasting in het land waarin je voor de overheid werkt. Het maakt niet uit in welk land je woont.

                <div class="space20"></div>

                <strong>Je werkt in het onderwijs</strong><br>
                Woon je in Nederland en ga je in België in het onderwijs werken? Of woon je in België en ga je in Nederland in het onderwijs werken? Dan betaal je belasting in je woonland voor een periode van maximaal 2 jaar vanaf de dag dat je begint te werken.<br><br>
                Je moet wel voldoen aan alle volgende voorwaarden:
                <ul>
                    <li>Je verblijft in het land waar je onderwijs geeft, maar je emigreert niet naar dit land.</li>
                    <li>Je geeft in het werkland onderwijs of je doet wetenschappelijk onderzoek aan een universiteit of andere officieel erkende onderwijsinstelling. Het wetenschappelijk onderzoek moet in het algemeen belang zijn, en niet in de eerste plaats voor het persoonlijk nut van iemand.</li>
                    <li>Je woont niet in het werkland in de periode dat je daar werkt.</li>
                </ul>

                <div class="space20"></div>

                <strong>Je werkt aan boord van een schip of luchtvaartuig</strong><br>
                Werk je aan boord van een schip of luchtvaartuig in het internationale verkeer, of aan boord van een binnenvaartschip? Dan betaal je belasting in het land waar de onderneming gevestigd is (België of Nederland).<br><br>
                Voor dit werk geldt een 'exclusieve bronstaatheffing'. Dit betekent dat het land waar de leiding van de onderneming is gevestigd, het inkomen mag belasten. In het andere land telt dit inkomen wel mee voor de bepaling van het belastingtarief over eventueel ander in dat land te belasten inkomen. Dit heet het 'progressievoorbehoud'. In Nederland wordt bij de toekenning van inkomensafhankelijke toeslagen ook rekening gehouden met dat buitenlandse inkomen.

                <div class="space20"></div>

                <strong>Je werkt als freelancer</strong><br>
                Woon je in Nederland, dan betaal je over je inkomsten als freelancer in Nederland belasting. Maar heb je in België een 'vaste basis', zoals een kantoor of een winkel, dan zijn de inkomsten van die basis belast in België. Deze regeling geldt andersom ook: als je in België woont met een 'vaste basis' in Nederland.<br><br>
                Heb je in je woonland belastingvrijstelling, dan mag het werkland alsnog belasting heffen over je inkomen. In dat geval moet je dus in het werkland aangifte doen. Bel de BelastingTelefoon als je wilt weten of je in Nederland vrijstelling hebt voor je freelance-inkomsten.

                <div class="space20"></div>

                <strong>Je werkt als artiest</strong><br>
                Woon je in Nederland en lever je als artiest persoonlijk een artistieke prestatie in België, en ontvang je daarvoor een honorarium? Dan betaal je meestal in België belasting. Dat geldt ook als iemand anders dan jij het honorarium ontvangt, bijvoorbeeld de leidinggevende van het gezelschap waarvoor je werkt. Deze regeling geldt andersom ook: als je in België woont en in Nederland werkt als artiest.<br><br>
                Als je werkzaamheden voor ten minste 30% gefinancierd zijn door of namens de overheid van je woonland, dan betaal je belasting in je woonland. Dat is bijvoorbeeld het geval als het orkest of theatergezelschap waarvan je deel uitmaakt subsidie ontvangt.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingCompensatie">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseCompensatie" aria-expanded="false" aria-controls="collapseCompensatie">
                Compensatieregelingen voor Nederlandse grensarbeiders die werken in België
            </button>
        </h2>
        <div id="collapseCompensatie" class="accordion-collapse collapse" aria-labelledby="headingCompensatie"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                Woon je in Nederland en betaal je in België belasting over je inkomsten uit je werk in België? Dan kun je in aanmerking komen voor een financiële compensatie uit Nederland.

                <div class="space20"></div>

                <strong>Algemene compensatieregeling</strong><br>
                Met de algemene compensatieregeling krijg je compensatie voor het mislopen van bepaalde aftrekposten die je wel zou krijgen als je in Nederland zou werken, zoals de hypotheekrenteaftrek of een persoonsgebonden aftrek. Je kunt ook compensatie krijgen voor de heffingskorting van je niet- of weinig verdienende fiscale partner.<br><br>
                Je komt voor algemene compensatie in aanmerking als je beloningen of inkomen uit werk in België hebt.

                <div class="space20"></div>

                <strong>Bijzondere compensatieregeling voor grensarbeiders</strong><br>
                Je komt voor bijzondere compensatie in aanmerking als je op 31 december 2002 onder de zogenoemde 'grensarbeidersregeling' viel.<br><br>
                Je hebt geen recht meer op bijzondere compensatie als je van werkgever verandert, of als je inkomen niet lager is geworden door het wegvallen van de grensarbeidersregeling.<br><br>
                Verander je van werkgever door bijvoorbeeld een bedrijfsovername of fusie? Of ben je onvrijwillig ontslagen en vind je binnen 6 maanden een nieuwe dienstbetrekking in België? Dan behoud je het recht op bijzondere compensatie. Dat geldt ook als je je dienstbetrekking in België hervat na een detachering naar een ander land voor maximaal 12 maanden.

                <div class="space20"></div>

                <strong>Hoe vraag je algemene of bijzondere compensatie aan?</strong><br>
                Vraag de compensatie aan in een voorlopige aanslag of in je belastingaangifte.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingPensioenBelgie">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapsePensioenBelgie" aria-expanded="false" aria-controls="collapsePensioenBelgie">
                Pensioen uit België – waar betaal je belasting?
            </button>
        </h2>
        <div id="collapsePensioenBelgie" class="accordion-collapse collapse" aria-labelledby="headingPensioenBelgie"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                Woon je in Nederland en heb je een pensioen, lijfrente of socialezekerheidsuitkering uit België? Of woon je in België en heb je een pensioen, lijfrente of socialezekerheidsuitkering uit Nederland? Dan betaal je daarover meestal belasting in je woonland. Een uitzondering geldt als je uitkeringen samen meer zijn dan € 25.000 per jaar.<br><br>
                Er is ook sprake van een pensioen of lijfrente uit je werkland als je je pensioen of lijfrente in je werkland hebt opgebouwd en daarna hebt overgedragen aan een verzekeraar in je woonland.

                <div class="space20"></div>

                <strong>De € 25.000-grens</strong><br>
                Is het totaalbedrag van al je uitkeringen (inclusief je AOW en Anw) samen jaarlijks meer dan € 25.000? Dan betaal je in de volgende situaties belasting in het land waaruit je de uitkering krijgt:
                <ul>
                    <li>Je hebt bij het opbouwen van je uitkering een fiscaal voordeel gehad in het land waar je de uitkering opbouwde (je werkland). Voor de opbouw van je AOW of Anw is dit niet van belang.</li>
                    <li>Je betaalt over je uitkering niet het normale belastingtarief dat geldt voor vroegere arbeidsinkomsten. Of je betaalt in je woonland over minder dan 90% van je uitkering belasting.</li>
                </ul>

                <strong>Let op!</strong><br>
                Viel je al voor 2003 onder de grensarbeidersregeling? Dan heb je bij het opbouwen van je Belgische pensioen geen fiscaal voordeel in België gehad. Je betaalde toen belasting in Nederland. Vanaf 2003 heb je wel een fiscaal voordeel in België, want vanaf dat jaar betaal je belasting in België. Dit betekent dat je je pensioenuitkering moet splitsen in een deel van voor 2003 en een deel van na 2003.

                <div class="space20"></div>

                <strong>Afkoopsom pensioen of lijfrente</strong><br>
                Heb je het recht op je pensioen of lijfrente afgekocht? Dan betaal je de belasting over de afkoopsom in het land waar je eerder de premies voor de opbouw van dit recht van je inkomen hebt afgetrokken.

                <div class="space20"></div>

                <strong>Uitkering sociale zekerheid</strong><br>
                Woon je in Nederland en ontvang je uit België een uitkering in verband met overtolligheid, ziekte of invaliditeit, en is die uitkering niet aan te merken als pensioen? Dan betaal je over een periode van 1 jaar belasting in België. Je moet dan wel een dienstbetrekking in België hebben en daar loonbelasting betalen.<br><br>
                Heb je na dat eerste jaar naast je uitkering nog steeds looninkomsten uit dezelfde dienstbetrekking, dan betaal je ook na dat jaar in België belasting. Pas vanaf het moment dat je naast je uitkering géén looninkomsten meer hebt, betaal je belasting over de uitkering in Nederland.<br><br>
                Deze regeling geldt andersom ook, dus als je in België woont.

                <div class="space20"></div>

                <strong>Overheidspensioen</strong><br>
                Over je overheidspensioen betaal je belasting in het land waar je voor de overheid hebt gewerkt. Heb je echter de nationaliteit van je woonland, dan betaal je over het overheidspensioen uit het andere land toch in je woonland belasting.<br><br>
                <em>Voorbeeld:</em> Je hebt de Nederlandse nationaliteit en je woont ook in Nederland. Je krijgt een overheidspensioen uit België. Dan betaal je over dat pensioen belasting in Nederland. Heb je niet de Nederlandse nationaliteit, dan betaal je in België belasting.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingWerkenDuitsland">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseWerkenDuitsland" aria-expanded="false" aria-controls="collapseWerkenDuitsland">
                Werken in Duitsland – waar betaal je belasting?
            </button>
        </h2>
        <div id="collapseWerkenDuitsland" class="accordion-collapse collapse" aria-labelledby="headingWerkenDuitsland"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                <strong>Je werkt tijdelijk in loondienst in Duitsland</strong><br>
                Betaal je in Nederland belasting over je loon en ga je voor je Nederlandse werkgever tijdelijk in Duitsland werken? Dan blijf je in Nederland belasting betalen als je voldoet aan de volgende voorwaarden:
                <ul>
                    <li>Je verblijft in 12 maanden in totaal niet langer dan 183 dagen voor je werk in Duitsland. De periode van 12 maanden hoeft niet in 1 kalenderjaar te zijn. Het maximale aantal dagen hoeft ook niet aaneengesloten te zijn. Gewone arbeidsonderbrekingen met verblijf in Duitsland, zoals ziektedagen, weekenden en nationale feestdagen, tellen ook mee in het totaal van 183.</li>
                    <li>Je werkt in Duitsland niet voor rekening van een vaste inrichting van je werkgever. Er is sprake van een vaste inrichting als je werkgever in Duitsland een bedrijfsruimte duurzaam ter beschikking heeft, zoals een fabriek, werkplaats, magazijn of verkoopruimte.</li>
                </ul>
                Ben je langer dan 183 dagen in Duitsland, of betaalt de Duitse vaste inrichting jouw loonkosten, dan betaal je in Duitsland belasting over je loon. In dat geval kun je recht hebben op <strong>financiële compensatie</strong>.

                <div class="space20"></div>

                <strong>Je werkt voor de overheid</strong><br>
                Werk je voor de overheid, dan betaal je over het inkomen dat je hiermee verdient belasting in het land waar die overheid is gevestigd. Het maakt niet uit in welk land je woont.

                <div class="space20"></div>

                <strong>Je werkt in het onderwijs</strong><br>
                Ga je in Duitsland onderwijs geven of wetenschappelijk onderzoek doen en word je hiervoor betaald vanuit Nederland (bijvoorbeeld door een Nederlandse onderwijsinstelling)? Dan betaal je belasting in Nederland voor een periode van maximaal 2 jaar vanaf de dag dat je begint te werken.<br><br>
                Je moet wel voldoen aan alle volgende voorwaarden:
                <ul>
                    <li>Je verblijft in Duitsland, waar je onderwijs geeft.</li>
                    <li>Je geeft in Duitsland onderwijs of je doet wetenschappelijk onderzoek aan een universiteit of andere officieel erkende onderwijsinstelling.</li>
                    <li>Het wetenschappelijk onderzoek moet in het algemeen belang zijn, en niet in de eerste plaats voor het persoonlijk nut van iemand.</li>
                    <li>Je woont niet in Duitsland in de periode dat je daar werkt.</li>
                    <li>Deze regeling geldt voor onderwijsinstellingen van de overheid en particuliere onderwijsinstellingen die officieel erkend zijn door Nederland, en voor elk niveau (lagere scholen, middelbare scholen, (v)mbo, hbo en universitair onderwijs). Vraag je onderwijsinstelling of deze officieel erkend is door Nederland.</li>
                </ul>
                Ontvang je de vergoeding vanuit Duitsland, dan gelden de regels die staan bij <strong>Je werkt tijdelijk in loondienst</strong> of, als je voor een overheidsinstantie werkt, <strong>Je werkt voor de overheid</strong>.

                <div class="space20"></div>

                <strong>Je werkt op een internationaal bedrijventerrein</strong><br>
                Werk je in loondienst bij een onderneming die gevestigd is op een bedrijventerrein op de grens van Nederland en Duitsland? Dan betaal je belasting over je loon in het land waar je verplicht sociaal verzekerd bent. Ben je in Nederland sociaal verzekerd, dan betaal je in Nederland belasting. Ben je in Duitsland sociaal verzekerd, dan betaal je in Duitsland belasting.<br><br>
                Kijk op de website van <strong>Grensinfopunt</strong> waar je sociaal verzekerd bent.

                <div class="space20"></div>

                <strong>Je werkt voor een buitenlandse werkgever</strong><br>
                Werk je in Duitsland voor een werkgever die niet in Nederland of Duitsland is gevestigd? Dan betaal je in Duitsland belasting over je loon. Verblijf je in een periode van 12 maanden echter niet langer dan 183 dagen in Duitsland, dan betaal je in Nederland belasting – tenzij er sprake is van uitlening, uitzending of detachering naar Duitsland, of als je werkt voor een vaste inrichting in Duitsland.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingCompensatieDuitsland">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseCompensatieDuitsland" aria-expanded="false" aria-controls="collapseCompensatieDuitsland">
                Compensatieregeling als je in Duitsland werkt en belasting betaalt
            </button>
        </h2>
        <div id="collapseCompensatieDuitsland" class="accordion-collapse collapse" aria-labelledby="headingCompensatieDuitsland"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                Hoeveel belasting je betaalt over je inkomsten verschilt per land. Omdat je in Nederland gebruik kunt maken van je aftrekposten (hypotheekrente eigen woning, persoonsgebonden aftrek) betaal je mogelijk in Nederland minder inkomstenbelasting en premie volksverzekeringen dan in Duitsland.<br><br>
                Daarom is er tussen Nederland en Duitsland een compensatieregeling afgesproken. Werk je in loondienst, dan kun je dit verschil compenseren door in je belastingaangifte de compensatieregeling aan te vragen. Op je definitieve aanslag zie je dan hoeveel compensatie je krijgt. Ben je ondernemer of gepensioneerd, dan kun je in je aangifte de doorschuifregeling aanvragen.<br><br>
                Het bedrag van de compensatie is het verschil tussen:
                <ul>
                    <li>de Duitse belasting (inclusief 'Solidaritätszuschlag') over je looninkomsten, eventueel daarbij opgeteld de te betalen belasting en premies volksverzekeringen in Nederland</li>
                    <li>de belasting en premie volksverzekeringen die je over je looninkomsten in Nederland zou betalen</li>
                </ul>
                Lees meer over de compensatieregeling op deze website van de Belastingdienst: <a href="https://www.belastingdienst.nl/data/online_aangifte/ih2025/contextafhankelijkehelp/nlw/da/compensatieregeling_voor_duits_inkomen.htm" target="_blank">Compensatieregeling voor Duits inkomen</a>.
                <div class="space20"></div>

                <strong>Doorschuifregeling</strong><br>
                Je kunt ook kiezen voor de doorschuifregeling. De aftrekposten die je nu niet in mindering kunt brengen op de Nederlandse belasting, worden dan bewaard voor een later jaar.

                <div class="space20"></div>

                <strong>Duits loon omrekenen naar Nederlands loon</strong><br>
                Heb je Duits loon, dan moet je dat eerst omrekenen naar Nederlands loon voordat je aangifte doet. In je aangifte vul je daarna het Nederlandse loon in dat je hebt berekend. Je rekent je Duitse loon om met een hulpmiddel (zie hieronder).

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingDuitsPensioen">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseDuitsPensioen" aria-expanded="false" aria-controls="collapseDuitsPensioen">
                Duits pensioen – waar betaal je belasting?
            </button>
        </h2>
        <div id="collapseDuitsPensioen" class="accordion-collapse collapse" aria-labelledby="headingDuitsPensioen"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                Woon je in Nederland, dan betaal je over je pensioen uit Duitsland (deutsche Rente) meestal belasting in Nederland.

                <div class="space20"></div>

                <strong>Wat is een pensioen uit Duitsland?</strong><br>
                Een pensioen uit Duitsland is een pensioen dat je in Duitsland hebt opgebouwd. Vaak ontvang je dit pensioen ook uit Duitsland. Maar je kunt een Duits pensioen ook via een Nederlandse verzekeraar ontvangen, als je dit pensioen vanuit Duitsland hebt overgedragen naar die verzekeraar. Je hoeft je Duitse pensioen dus niet letterlijk uit Duitsland te ontvangen.

                <div class="space20"></div>

                <strong>Welk pensioen heb je?</strong><br>
                In Duitsland kun je 4 soorten pensioen opbouwen:
                <ul>
                    <li><strong>Wettelijk pensioen (socialezekerheidspensioen)</strong> – Een pensioen dat je hebt opgebouwd toen je via je werk verplicht verzekerd was voor de Duitse sociale verzekeringen (Rentenversicherung), zoals de Altersrente of een uitkering van de Deutsche Rentenversicherung.</li>
                    <li><strong>Overheidspensioen</strong> – Een pensioen dat je hebt opgebouwd toen je voor de Duitse overheid werkte.</li>
                    <li><strong>Bedrijfspensioen</strong> – Een pensioen dat je hebt opgebouwd toen je voor een Duits bedrijf werkte.</li>
                    <li><strong>Lijfrente-uitkering</strong> – Een uitkering uit een lijfrenteverzekering.</li>
                </ul>

                <div class="space20"></div>

                <strong>Je betaalt meestal belasting in Nederland</strong><br>
                Woon je in Nederland, dan betaal je over je Duitse pensioen meestal in Nederland belasting. In je belastingaangifte in Nederland vul je je Duitse pensioen of lijfrente in bij 'Pensioen en andere uitkeringen'.<br>
                In Duitsland hoef je geen aangifte te doen, als je dat aan de Duitse belastingdienst vraagt met het formulier <em>Verklaring belastingaangifte Duits pensioen</em>.

                <div class="space20"></div>

                <strong>Je betaalt soms belasting in Duitsland</strong><br>
                Je betaalt belasting in Duitsland als het totaalbedrag van de volgende pensioenen uit Duitsland in een jaar samen meer is dan € 15.000:
                <ul>
                    <li>Wettelijk pensioen (socialezekerheidspensioen)</li>
                    <li>Bedrijfspensioen</li>
                    <li>Lijfrente-uitkering</li>
                </ul>
                Een Duits overheidspensioen of een socialezekerheidsuitkering (zoals Krankengeld, Mutterschafsgeld of Elterngeld) telt niet mee bij de berekening van de € 15.000-grens.

                <div class="space20"></div>

                Je betaalt ook belasting in Duitsland in de volgende situaties:
                <ul>
                    <li>Je ontvangt een Duits overheidspensioen en je hebt niet de Nederlandse nationaliteit.</li>
                    <li>Je hebt een VBL-rente (dit is een bedrijfspensioen van het Versorgungsanstalt des Bundes und der Länder voor voormalige werknemers van de Duitse overheid).</li>
                    <li>Je ontvangt een socialezekerheidsuitkering uit Duitsland, zoals Krankengeld, Mutterschafsgeld of Elterngeld.</li>
                    <li>Je ontvangt een afkoopsom van een pensioen of lijfrente uit Duitsland.</li>
                </ul>

                <div class="space20"></div>

                <strong>Premies volksverzekeringen en bijdrage Zvw</strong><br>
                Woon je in Nederland, dan betaal je premies volksverzekeringen (AOW, Anw en Wlz) en bijdrage Zorgverzekeringswet (Zvw) over je pensioen uit Duitsland. Dit geldt als je alleen een pensioen uit Duitsland hebt, of als je naast je Duitse pensioen ook Nederlands inkomen hebt, zoals AOW of loon.

                <div class="space20"></div>

                <strong>Geen of minder premies of bijdrage Zvw</strong><br>
                Je betaalt geen of minder premies of bijdrage Zvw in de volgende situaties:
                <ul>
                    <li>Je ontving vóór 1 mei 2010 al een Duits pensioen en je betaalt nog steeds in Duitsland je sociale premies.</li>
                    <li>Je hebt een ontheffing van de verzekeringsplicht voor de AOW en de Anw.</li>
                    <li>Je hebt de AOW-leeftijd bereikt – je betaalt dan geen premie AOW meer.</li>
                    <li>Je hebt alleen een Duits pensioen en je hebt in Duitsland een wettelijke ziektekostenverzekering. Vraag bij de SVB een ontheffing van de premieplicht aan.</li>
                </ul>

                <div class="space20"></div>

                <strong>Vraag een tegemoetkoming aan in Duitsland</strong><br>
                Woon je in Nederland en heb je premie Wlz en bijdrage Zvw betaald? Dan kun je hiervoor in Duitsland een tegemoetkoming aanvragen als je aan alle volgende voorwaarden voldoet:
                <ul>
                    <li>Je hebt aangifte gedaan over het jaar waarvoor je de tegemoetkoming aanvraagt.</li>
                    <li>Je hebt je Duitse pensioen aangegeven in je aangifte.</li>
                    <li>Je hebt een definitieve aanslag inkomstenbelasting/premie volksverzekeringen ontvangen.</li>
                    <li>Je hebt een aanslag bijdrage Zvw ontvangen.</li>
                </ul>
                Voldoe je hieraan, download dan het 'Aanvraagformulier Zulage' op de website van Grensinfopunt en stuur het naar de Deutsche Rentenversicherung (DRV).

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingLoonOmrekenen">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseLoonOmrekenen" aria-expanded="false" aria-controls="collapseLoonOmrekenen">
                Belgisch of Duits loon omrekenen naar Nederlands loon
            </button>
        </h2>
        <div id="collapseLoonOmrekenen" class="accordion-collapse collapse" aria-labelledby="headingLoonOmrekenen"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">

                Werk je in België of Duitsland en woon je in Nederland? Dan moet je ook in Nederland aangifte inkomstenbelasting doen. Daarvoor moet je je buitenlandse loon omrekenen naar Nederlands loon. Dat kun je zelf doen met dit hulpmiddel. In het hulpmiddel moet je alle bedragen afronden. Je mag afronden in je voordeel.<br><br>
                Een uitkering uit België of Duitsland hoef je niet om te rekenen. De uitkering geef je in je aangifte inkomstenbelasting aan bij het onderdeel 'Pensioen en andere uitkeringen uit het buitenland'.

                <div class="space20"></div>

                <strong>Zorg dat je de volgende gegevens bij de hand hebt:</strong>
                <ul>
                    <li>Bij Belgisch loon: alle opgaven van je Belgische werkgever(s), bijvoorbeeld je individuele rekening, je loonfiche of je maandstaten.</li>
                    <li>Bij Duits loon: je jaaropgaven (Lohnsteuerbescheinigung) van je Duitse werkgever(s).</li>
                </ul>

                <snelstart-ui-button>
                    <a href="https://www.belastingdienst.nl/wps/wcm/connect/nl/buitenland/content/hulpmiddel-belgisch-of-duits-loon-omrekenen-naar-nederlands-loon" target="_blank>" type="link">
                        Hulpmiddel omrekenen (Belastingdienst)
                    </a>
                </snelstart-ui-button>

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Werkkostenregeling
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Werkt iemand buiten Nederland in loondienst? Of werkt iemand in Nederland voor een werkgever buiten
                Nederland die in Nederland geen vestiging of vaste vertegenwoordiger heeft? Dan houdt de werkgever
                geen
                loonheffing in op het loon. In de aangifte geef je dan het brutoloon aan inclusief vergoedingen. Van
                dit
                brutoloon mag je in het jaar 2024 1,92% (tot een brutoloon van € 400.000, daarboven 1,18%)
                aftrekken.
                Dit heet de werkkostenregeling.
                <div class="space10"></div>

                Let op! Vergoedingen en verstrekkingen waarvoor een gerichte vrijstelling geldt, tellen niet mee als
                brutoloon. Bijvoorbeeld een reiskostenvergoeding voor zakelijk gebruik van de privé-auto. Je moet
                deze
                vergoedingen en verstrekkingen eerst van het brutoloon aftrekken voordat je de aftrek
                werkkostenregeling
                berekent. Van de werkgever kun je een overzicht krijgen van de ontvangen vergoedingen en
                verstrekkingen.
            </div>
        </div>

    </div>
</div>
